import React, { useEffect, useState } from "react";
import { getBankAll } from "../../../../MasterData/_redux/bank/bankCrud";
import { getBankAccountAll } from "../../../../MasterData/_redux/bank-account/bankAccountCrud";

export function ImportMutationBankEditForm({ data }) {
  const [bankData, setBankData] = useState({
    bank: {},
    account_number: "",
  });

  useEffect(() => {
    getValue();
  }, [data]);

  const getValue = () => {
    getBankAccountAll().then((res) => {
      if (data) {
        const bankAccount = res.data.data.find(
          (item) => item.uuid === data.bank_account_uuid
        );
        setBankData(bankAccount);
      }
    });
  };

  return (
    <>
      <div className="form-group row">
        <div className="col-lg-6 row">
          <div className="col-lg-4">
            <h6>Nama Bank :</h6>
          </div>
          <div className="col-lg-8">
            <h6>{bankData.bank.name}</h6>
          </div>
        </div>
        <div className="col-lg-6 row">
          <div className="col-lg-4">
            <h6>No Rekening :</h6>
          </div>
          <div className="col-lg-8">
            <h6>{bankData.account_number}</h6>
          </div>
        </div>
      </div>
    </>
  );
}
